export default __webpack_public_path__ + "114a0160696b5edf0eabafbd69b170e5.svg";